module.exports = __webpack_public_path__ + "static/drevojan-c0878d360ba376cde4bb516adad72515.jpg";